import * as React from "react";

import { cn } from "@/lib/utils";
import { NvButton } from "./nv-button";

// Figma "Search Bar": natural-language query input + primary "검색" button (HOME · Agent Finder).
export interface NvSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
  placeholder?: string;
  buttonLabel?: string;
  disabled?: boolean;
  className?: string;
}

function NvSearchBar({
  value,
  onChange,
  onSubmit,
  placeholder = "필요한 에이전트를 자연어로 검색해 보세요",
  buttonLabel = "검색",
  disabled,
  className,
}: NvSearchBarProps) {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const query = value.trim();
    if (query) onSubmit(query);
  };

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className={cn(
        "flex items-center gap-3 rounded-nv-card border border-nv-border-strong bg-nv-surface py-[10px] pl-5 pr-[10px] focus-within:border-nv-brand",
        className,
      )}
    >
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        aria-label={placeholder}
        className="min-w-0 flex-1 bg-transparent text-nv-body-lg text-nv-text-strong placeholder:text-nv-text-placeholder focus:outline-none"
      />
      <NvButton type="submit" size="md" disabled={disabled || !value.trim()}>
        {buttonLabel}
      </NvButton>
    </form>
  );
}

export { NvSearchBar };
